(function () {
  var ROOT_SELECTOR = '[data-cookie-consent]';
  var PRIVACY_FEATURE = [{ name: 'consent-tracking-api', version: '0.1' }];
  var CONSENT_KEYS = ['preferences', 'analytics', 'marketing', 'sale_of_data'];
  var loadedScripts = {};

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function normaliseConsentValue(value) {
    return value === true || value === 'true' || value === 'yes' || value === '1' || value === 1;
  }

  function hasConsentSignal(value) {
    return value === true || value === false || value === 'true' || value === 'false' || value === 'yes' || value === 'no' || value === '1' || value === '0';
  }

  function getConsentValue(source, key) {
    if (!source) return undefined;
    if (key === 'sale_of_data' && typeof source.saleOfData !== 'undefined') return source.saleOfData;
    return source[key];
  }

  function isFocusable(element) {
    return !element.disabled && element.getClientRects().length > 0 && !element.closest('[hidden]');
  }

  function getCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(PRIVACY_FEATURE, function () {
        callback(window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
      });
      return;
    }

    callback(null);
  }

  function defaultConfig() {
    return {
      version: 'fallback',
      storageKey: 'bananaoptics_cookie_consent',
      intro: {
        title: 'Cookies on BananaOptics',
        paragraphs: ['We use cookies and similar technologies to operate the store and improve your experience.'],
        accordions: []
      },
      tabs: [],
      scripts: []
    };
  }

  function CookieConsent(root) {
    this.root = root;
    this.config = null;
    this.customerPrivacy = null;
    this.state = null;
    this.activeScreen = 'intro';
    this.activeTab = null;
    this.activeGroup = null;
    this.previousFocus = null;
  }

  CookieConsent.prototype.init = function () {
    var instance = this;
    var configUrl = this.root.getAttribute('data-config-url');

    this.bindStaticEvents();
    this.bindOpenTriggers();

    fetch(configUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load cookie consent config');
        return response.json();
      })
      .catch(function () {
        return defaultConfig();
      })
      .then(function (config) {
        instance.config = config;
        instance.state = instance.getDefaultState();
        instance.render();

        getCustomerPrivacy(function (customerPrivacy) {
          instance.customerPrivacy = customerPrivacy;
          instance.bootFromSavedState();
        });
      });
  };

  CookieConsent.prototype.bindStaticEvents = function () {
    var instance = this;

    this.root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-consent-action]');
      var introToggle = event.target.closest('[data-consent-intro-toggle]');
      var itemToggle = event.target.closest('[data-consent-item-toggle]');
      var tab = event.target.closest('[data-consent-tab]');
      var group = event.target.closest('[data-consent-group]');

      if (action) {
        instance.handleAction(action.getAttribute('data-consent-action'));
        return;
      }

      if (introToggle) {
        instance.toggleDisclosure(introToggle);
        return;
      }

      if (itemToggle) {
        instance.toggleDisclosure(itemToggle);
        return;
      }

      if (tab) {
        instance.activeTab = tab.getAttribute('data-consent-tab');
        instance.activeGroup = null;
        instance.renderManagePanel();
        return;
      }

      if (group) {
        instance.activeGroup = group.getAttribute('data-consent-group');
        instance.renderManagePanel();
      }
    });

    this.root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-consent-input]');

      if (!input) return;

      instance.state.items[input.getAttribute('data-consent-input')] = input.checked;
      instance.state.shopifyConsent = instance.collectShopifyConsent();
    });

    document.addEventListener('keydown', function (event) {
      if (instance.root.hidden) return;

      if (event.key === 'Tab') {
        instance.trapFocus(event);
      }
    });

    document.addEventListener('visitorConsentCollected', function () {
      instance.loadConsentedScripts();
    });
  };

  CookieConsent.prototype.bindOpenTriggers = function () {
    var instance = this;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cookie-consent-open]');

      if (!trigger) return;

      event.preventDefault();
      instance.show('manage');
    });
  };

  CookieConsent.prototype.handleAction = function (action) {
    if (action === 'manage') {
      this.show('manage');
      return;
    }

    if (action === 'accept-all') {
      this.setAllInteractiveItems(true);
      this.save('accepted');
      return;
    }

    if (action === 'reject-all') {
      this.setAllInteractiveItems(false);
      this.save('rejected');
      return;
    }

    if (action === 'save') {
      this.save('custom');
    }
  };

  CookieConsent.prototype.bootFromSavedState = function () {
    var storedState = this.readStoredState();
    var shopifyState = this.readShopifyState();

    if (storedState) {
      this.state = storedState;
      this.state.shopifyConsent = this.collectShopifyConsent();
      this.loadConsentedScripts();
      return;
    }

    if (shopifyState) {
      this.state = shopifyState;
      this.state.shopifyConsent = this.collectShopifyConsent();
      this.loadConsentedScripts();
      return;
    }

    if (this.customerPrivacy && typeof this.customerPrivacy.shouldShowBanner === 'function' && !this.customerPrivacy.shouldShowBanner()) {
      this.setAllInteractiveItems(true);
      this.save('auto-accepted');
      return;
    }

    this.show('intro');
  };

  CookieConsent.prototype.getStorageKey = function () {
    return (this.config && this.config.storageKey ? this.config.storageKey : 'bananaoptics_cookie_consent') + '_' + (this.config && this.config.version ? this.config.version : 'v1');
  };

  CookieConsent.prototype.readStoredState = function () {
    var raw;
    var parsed;

    try {
      raw = window.localStorage.getItem(this.getStorageKey());
      parsed = raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }

    if (!parsed || parsed.version !== this.config.version || !parsed.items) return null;

    return {
      version: parsed.version,
      status: parsed.status || 'custom',
      updatedAt: parsed.updatedAt || null,
      items: Object.assign(this.getDefaultItems(), parsed.items),
      shopifyConsent: parsed.shopifyConsent || null
    };
  };

  CookieConsent.prototype.writeStoredState = function (status) {
    var record = {
      version: this.config.version,
      status: status,
      updatedAt: new Date().toISOString(),
      items: this.state.items,
      shopifyConsent: this.state.shopifyConsent
    };

    try {
      window.localStorage.setItem(this.getStorageKey(), JSON.stringify(record));
    } catch (error) {
      return;
    }
  };

  CookieConsent.prototype.readShopifyState = function () {
    var current;
    var hasSignal = false;
    var items = this.getDefaultItems();
    var instance = this;

    if (!this.customerPrivacy || typeof this.customerPrivacy.currentVisitorConsent !== 'function') return null;

    try {
      current = this.customerPrivacy.currentVisitorConsent();
    } catch (error) {
      return null;
    }

    if (!current) return null;

    CONSENT_KEYS.forEach(function (key) {
      if (hasConsentSignal(getConsentValue(current, key))) {
        hasSignal = true;
      }
    });

    if (!hasSignal) return null;

    this.getAllItems().forEach(function (item) {
      var keys = asArray(item.consentKeys);

      if (!keys.length || item.required) return;

      items[item.id] = keys.every(function (key) {
        return normaliseConsentValue(getConsentValue(current, key));
      });
    });

    return {
      version: this.config.version,
      status: 'shopify',
      updatedAt: null,
      items: items,
      shopifyConsent: instance.collectShopifyConsentFromItems(items)
    };
  };

  CookieConsent.prototype.getDefaultState = function () {
    return {
      version: this.config ? this.config.version : null,
      status: 'new',
      updatedAt: null,
      items: this.getDefaultItems(),
      shopifyConsent: null
    };
  };

  CookieConsent.prototype.getDefaultItems = function () {
    var items = {};

    this.getAllItems().forEach(function (item) {
      if (item.required || item.type === 'info') return;

      if (asArray(item.consentKeys).length || item.allowObjection) {
        items[item.id] = item.default === true;
      }
    });

    return items;
  };

  CookieConsent.prototype.getAllItems = function () {
    var items = [];

    asArray(this.config && this.config.tabs).forEach(function (tab) {
      asArray(tab.groups).forEach(function (group) {
        asArray(group.items).forEach(function (item) {
          items.push(Object.assign({ groupId: group.id, tabId: tab.id }, item));
        });
      });
    });

    return items;
  };

  CookieConsent.prototype.getConsentItems = function () {
    return this.getAllItems().filter(function (item) {
      return asArray(item.consentKeys).length && item.type !== 'info' && !item.required && !item.isVendor;
    });
  };

  CookieConsent.prototype.getVendorConsentItems = function () {
    return this.getAllItems().filter(function (item) {
      return asArray(item.consentKeys).length && item.type !== 'info' && !item.required && item.isVendor;
    });
  };

  CookieConsent.prototype.setAllInteractiveItems = function (value) {
    var items = Object.assign({}, this.state.items);

    this.getAllItems().forEach(function (item) {
      if (item.required || item.type === 'info') return;

      if (asArray(item.consentKeys).length || item.allowObjection) {
        items[item.id] = value;
      }
    });

    this.state.items = items;
    this.state.shopifyConsent = this.collectShopifyConsent();
    this.renderManagePanel();
  };

  CookieConsent.prototype.collectShopifyConsent = function () {
    return this.collectShopifyConsentFromItems(this.state.items);
  };

  CookieConsent.prototype.collectShopifyConsentFromItems = function (items) {
    var purposeItems = this.getConsentItems();
    var vendorItems = this.getVendorConsentItems();
    var consent = {};

    CONSENT_KEYS.forEach(function (key) {
      var purposesForKey = purposeItems.filter(function (item) {
        return asArray(item.consentKeys).indexOf(key) !== -1;
      });
      var vendorsForKey = vendorItems.filter(function (item) {
        return asArray(item.consentKeys).indexOf(key) !== -1;
      });
      var purposeAllows = purposesForKey.length
        ? purposesForKey.some(function (item) { return items[item.id] === true; })
        : false;
      var vendorAllows = vendorsForKey.length
        ? vendorsForKey.some(function (item) { return items[item.id] === true; })
        : true;

      consent[key] = purposeAllows && vendorAllows;
    });

    return consent;
  };

  CookieConsent.prototype.save = function (status) {
    var instance = this;

    this.state.status = status;
    this.state.updatedAt = new Date().toISOString();
    this.state.shopifyConsent = this.collectShopifyConsent();
    this.writeStoredState(status);
    this.sendShopifyConsent(function () {
      instance.hide();
      instance.loadConsentedScripts();
      document.dispatchEvent(new CustomEvent('bananaoptics:cookieConsentChanged', { detail: instance.state }));
    });
  };

  CookieConsent.prototype.sendShopifyConsent = function (callback) {
    var consent = Object.assign({}, this.state.shopifyConsent);

    if (!this.customerPrivacy || typeof this.customerPrivacy.setTrackingConsent !== 'function') {
      callback();
      return;
    }

    try {
      this.customerPrivacy.setTrackingConsent(consent, callback);
    } catch (error) {
      delete consent.sale_of_data;

      try {
        this.customerPrivacy.setTrackingConsent(consent, callback);
      } catch (fallbackError) {
        callback();
      }
    }
  };

  CookieConsent.prototype.render = function () {
    var intro = this.config.intro || {};
    var title = this.root.querySelector('[data-consent-title]');
    var copy = this.root.querySelector('[data-consent-intro-copy]');
    var list = this.root.querySelector('[data-consent-intro-list]');
    var policyLink = this.root.querySelector('[data-consent-policy-link]');
    var policyUrl = this.root.getAttribute('data-policy-url');

    if (title) title.textContent = intro.title || 'Cookies on BananaOptics';
    if (policyLink && policyUrl) policyLink.setAttribute('href', policyUrl);

    if (copy) {
      copy.innerHTML = asArray(intro.paragraphs).map(function (paragraph) {
        return '<p>' + escapeHtml(paragraph) + '</p>';
      }).join('');
    }

    if (list) {
      list.innerHTML = asArray(intro.accordions).map(function (item, index) {
        var id = 'CookieConsentIntro-' + escapeHtml(item.id || index);

        return [
          '<div class="cookie-consent__intro-item">',
          '<button type="button" class="cookie-consent__intro-button" data-consent-intro-toggle aria-expanded="' + (index === 0 ? 'true' : 'false') + '" aria-controls="' + id + '">',
          '<span class="cookie-consent__chevron" aria-hidden="true"></span>',
          '<span>' + escapeHtml(item.label) + '</span>',
          '</button>',
          '<p id="' + id + '" class="cookie-consent__intro-detail"' + (index === 0 ? '' : ' hidden') + '>' + escapeHtml(item.description) + '</p>',
          '</div>'
        ].join('');
      }).join('');
    }

    this.activeTab = this.activeTab || (asArray(this.config.tabs)[0] && this.config.tabs[0].id);
    this.renderManagePanel();
  };

  CookieConsent.prototype.renderManagePanel = function () {
    var tabs = asArray(this.config.tabs);
    var tab = tabs.find(function (candidate) {
      return candidate.id === this.activeTab;
    }, this) || tabs[0];
    var groups = asArray(tab && tab.groups);
    var group = groups.find(function (candidate) {
      return candidate.id === this.activeGroup;
    }, this) || groups[0];
    var tabList = this.root.querySelector('[data-consent-tabs]');
    var groupList = this.root.querySelector('[data-consent-basis-tabs]');
    var panel = this.root.querySelector('[data-consent-panel]');

    if (!tab || !group) return;

    this.activeTab = tab.id;
    this.activeGroup = group.id;

    if (tabList) {
      tabList.innerHTML = tabs.map(function (candidate) {
        return '<button type="button" class="cookie-consent__tab" role="tab" data-consent-tab="' + escapeHtml(candidate.id) + '" aria-selected="' + (candidate.id === tab.id ? 'true' : 'false') + '">' + escapeHtml(candidate.label) + '</button>';
      }).join('');
    }

    if (groupList) {
      groupList.innerHTML = groups.map(function (candidate) {
        return '<button type="button" class="cookie-consent__tab" role="tab" data-consent-group="' + escapeHtml(candidate.id) + '" aria-selected="' + (candidate.id === group.id ? 'true' : 'false') + '">' + escapeHtml(candidate.label) + '</button>';
      }).join('');
    }

    if (panel) {
      panel.innerHTML = [
        '<h3 class="cookie-consent__panel-title">' + escapeHtml(group.label) + '</h3>',
        '<p class="cookie-consent__panel-description">' + escapeHtml(group.description) + '</p>',
        '<div class="cookie-consent__items">',
        asArray(group.items).map(this.renderItem.bind(this)).join(''),
        '</div>'
      ].join('');
    }
  };

  CookieConsent.prototype.renderItem = function (item) {
    var id = 'CookieConsentItem-' + item.id;
    var checked = this.state.items[item.id] === true;
    var hasToggle = !item.required && item.type !== 'info' && (asArray(item.consentKeys).length || item.allowObjection);
    var badge = item.required
      ? '<span class="cookie-consent__badge cookie-consent__badge--required">Required</span>'
      : (item.groupId === 'user_consent' ? '<span class="cookie-consent__badge">C</span>' : '');
    var switchMarkup = hasToggle
      ? [
        '<label class="cookie-consent__switch">',
        '<span class="visually-hidden">' + escapeHtml(item.label) + '</span>',
        '<input type="checkbox" data-consent-input="' + escapeHtml(item.id) + '"' + (checked ? ' checked' : '') + '>',
        '<span aria-hidden="true"></span>',
        '</label>'
      ].join('')
      : '';
    var vendors = asArray(item.vendors).length
      ? '<div class="cookie-consent__vendors">' + asArray(item.vendors).map(function (vendor) {
        return '<span class="cookie-consent__vendor">' + escapeHtml(vendor) + '</span>';
      }).join('') + '</div>'
      : '';

    return [
      '<div class="cookie-consent__item">',
      '<div class="cookie-consent__item-row">',
      '<button type="button" class="cookie-consent__item-trigger" data-consent-item-toggle aria-expanded="false" aria-controls="' + escapeHtml(id) + '">',
      '<span class="cookie-consent__chevron" aria-hidden="true"></span>',
      '<span class="cookie-consent__item-label">' + escapeHtml(item.label) + '</span>',
      badge,
      '</button>',
      switchMarkup,
      '</div>',
      '<div id="' + escapeHtml(id) + '" class="cookie-consent__item-detail" hidden>',
      escapeHtml(item.description),
      vendors,
      '</div>',
      '</div>'
    ].join('');
  };

  CookieConsent.prototype.toggleDisclosure = function (button) {
    var expanded = button.getAttribute('aria-expanded') === 'true';
    var target = document.getElementById(button.getAttribute('aria-controls'));

    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (target) target.hidden = expanded;
  };

  CookieConsent.prototype.show = function (screen) {
    this.previousFocus = document.activeElement;
    this.activeScreen = screen || 'intro';
    this.root.hidden = false;
    this.root.querySelectorAll('[data-consent-screen]').forEach(function (screenEl) {
      screenEl.hidden = screenEl.getAttribute('data-consent-screen') !== this.activeScreen;
    }, this);
    document.documentElement.classList.add('cookie-consent-lock');
    this.renderManagePanel();
    this.focusFirstControl();
  };

  CookieConsent.prototype.hide = function () {
    this.root.hidden = true;
    document.documentElement.classList.remove('cookie-consent-lock');

    if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
      this.previousFocus.focus();
    }
  };

  CookieConsent.prototype.focusFirstControl = function () {
    var focusable = this.root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var visible = Array.prototype.filter.call(focusable, isFocusable);

    if (visible[0]) visible[0].focus();
  };

  CookieConsent.prototype.trapFocus = function (event) {
    var focusable = this.root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var visible = Array.prototype.filter.call(focusable, isFocusable);
    var first = visible[0];
    var last = visible[visible.length - 1];

    if (!first || !last) return;

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  CookieConsent.prototype.loadConsentedScripts = function () {
    var consent = this.state && this.state.shopifyConsent ? this.state.shopifyConsent : this.collectShopifyConsent();
    var instance = this;

    asArray(this.config.scripts).forEach(function (script) {
      if (loadedScripts[script.id]) return;

      var consentAllowed = asArray(script.requiresConsent).every(function (key) {
        return consent[key] === true;
      });
      var itemAllowed = asArray(script.requiresItems).every(function (itemId) {
        return instance.state.items[itemId] === true;
      });

      if (!consentAllowed || !itemAllowed) return;

      instance.loadScript(script);
      loadedScripts[script.id] = true;
    });
  };

  CookieConsent.prototype.loadScript = function (script) {
    if (script.provider === 'microsoft_clarity' && script.tagId) {
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

      var tag = document.createElement('script');
      var firstScript = document.getElementsByTagName('script')[0];

      tag.async = true;
      tag.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(script.tagId);
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(tag, firstScript);
      } else {
        document.head.appendChild(tag);
      }
    }
  };

  ready(function () {
    var root = document.querySelector(ROOT_SELECTOR);

    if (!root) return;

    new CookieConsent(root).init();
  });
})();
